import api from '@services/interceptor';
import { localStorageService } from '@stores/localStorage.service';
import { useAuthStore } from '@store/auth';
import { useWorkspaceStore } from '@store/WorkspaceData';
import { satService } from '@requests/Main/sat.service';
import { tarService } from '@requests/Main/target.service';
import { timeService } from '@requests/Main/time.service';
import { planService } from '@requests/Main/plan.service';
export class MainService {
  constructor(){
    this.auth = useAuthStore() 
    this.wp = useWorkspaceStore() 
  }
  async initGlobaldata(selectWp){
    await this.wp.clear()
    if(await this.auth.SelectWP(selectWp)){
      this.wp.wpid = selectWp
      this.wp.sat = await satService.GetSat() || []
      this.wp.targets = await tarService.Get() || []
      this.wp.time = await timeService.Get() || []
      this.wp.experiment.Sat = this.wp.sat[0]
      this.wp.experiment.Tar = this.wp.targets[0]
      // Пока работаем с одним КА — заявка всегда назначена на него
      const sat = this.wp.experiment.Sat
      const tar = this.wp.experiment.Tar
      if(sat && tar && tar.satelliteId !== sat.id){
        tar.satelliteId = sat.id
        await tarService.Put(tar)
      }
      if(tar) this.wp.experiment.Plan = await planService.Get(tar.id)
      console.log("Данные запуска", this.wp)
      // получение заявок
      return true
    }
    // получить информацию о выбранном wp
    // запросить все глобальные данные 
    // 
    return false
  }
  logOut(){
    this.wp.clear()
    this.auth.logout()
    localStorageService.clear();
    delete api.defaults.headers.common['Authorization'];
  }
  getWpList() {
    const wp = this.auth.workSpaces
    return wp
  }
  
}